import { Injectable } from '@angular/core';
import { WindowService } from './window.service';

@Injectable({
    providedIn: 'root'
})
export class NewTabPageService {
    private readonly ntpApi: NewTabPageApi;

    constructor(
        private readonly windowService: WindowService
    ) {
        this.ntpApi = this.windowService.nativeWindow.chrome && this.windowService.nativeWindow.chrome.embeddedSearch && this.windowService.nativeWindow.chrome.embeddedSearch.newTabPage;
    }

    public isAvailable(): boolean {
        return !!this.ntpApi;
    }

    public logHistogram(event: NTPEvent): boolean {
        if (this.ntpApi) {
            this.ntpApi.logEvent(event);
            return true;
        }

        return false;
    }

    public isDarkMode(): boolean {
        return this.ntpApi && this.ntpApi.themeBackgroundInfo && this.ntpApi.themeBackgroundInfo.isNtpBackgroundDark;
    }
}
